import { NavButton } from './NavButton'

type CueCardsButtonProps = {
    id: string
    disabled?: boolean
    onClick?: () => void
}

const CueCardsButton: React.FC<CueCardsButtonProps> = ({ id, disabled, onClick }) => (
    <NavButton
        id={id}
        text='Cue Cards'
        path='/teacher/classroom/cue-cards'
        icon={'ImageRounded'}
        disabled={disabled}
        onClick={onClick}
    />
)

export { CueCardsButton }
